import { render, staticRenderFns } from "./CardSolution.vue?vue&type=template&id=5b1965c6&"
import script from "./CardSolution.vue?vue&type=script&lang=js&"
export * from "./CardSolution.vue?vue&type=script&lang=js&"
import style0 from "./CardSolution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports